import React, {useEffect} from 'react';
import {Route, Routes, useNavigate} from 'react-router-dom';
import Main from "./pages/Main";
import {PrivateRoute} from "../router/PrivateRoute";
import Login from "./pages/Login";
import Tracing from "./pages/Tracing";
import Emails from "./pages/Emails";
import Logs from "./pages/Logs";
import {useAppSelector} from "../store/hooks";
import useFrameConnect from "../hooks/useFrameConnect";

function App() {
    const authUser = useAppSelector(state => state.auth.authUser)

    useFrameConnect()

    return (
        <Routes>
            <Route path='/' element={<PrivateRoute />}>
                <Route path="/" index={true} element={<Main />} />
            </Route>
            {authUser && !authUser.isTester && <>
                <Route path='/logs' element={<PrivateRoute />}>
                    <Route path="/logs" index={true} element={<Logs />} />
                </Route>
                <Route path='/tracing' element={<PrivateRoute />}>
                    <Route path="/tracing" element={<Tracing />} />
                </Route>
                <Route path='/emails' element={<PrivateRoute />}>
                    <Route path="/emails" element={<Emails />} />
                </Route>
            </>}
            <Route path="/login" element={<Login />} />
        </Routes>
    );
}

export default App;
